import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="bg-steel py-5 sm:py-8" data-id="element-60" data-mp="1o3x1pk7r0m0y">
      <div className="mx-auto flex max-w-5xl flex-col items-center gap-3 px-4 text-center sm:flex-row sm:gap-5 sm:px-6 sm:text-left" data-id="element-61" data-mp="1o33y2s436cn1">
        <div className="flex h-20 w-20 shrink-0 flex-col items-center justify-center rounded-full border-4 border-electric bg-navy text-white sm:h-24 sm:w-24" data-id="element-62" data-mp="1x4bravrqwna9">
          <ShieldCheckIcon className="h-7 w-7 text-electric sm:h-8 sm:w-8" strokeWidth={2} aria-hidden="true" data-id="element-63" data-mp="19fac8poeqdw0" />
          <span className="mt-0.5 font-display text-xs font-extrabold uppercase leading-none tracking-wide" data-id="element-64" data-mp="14dl1lb53k28g">
            7 days
          </span>
        </div>
        <div data-id="element-65" data-mp="1edkdni0q6aq2">
          <h2 className="text-xl leading-tight text-navy sm:text-3xl" data-id="element-66" data-mp="1ed26vrgfse3w">
            Your purchase is <span className="text-electric" data-id="element-67" data-mp="qn7v7d7usvl8">100% protected</span>
          </h2>
          <p className="mt-1.5 text-sm font-medium leading-snug text-muted sm:text-base" data-id="element-68" data-mp="lpoiwiupusvx">
            Explore HOME APPLIANCE DIAGNOSTIC PRO™ for 7 days. Access the complete
            6-module visual diagnostic system and all 5 strategic bonuses. If it isn't
            right for you, contact us within 7 days for a full refund according to the
            refund terms.
          </p>
        </div>
      </div>
    </section>;
}